module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (246).d471b032.jpg";